import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as segment from './scripts/segment';
segment.init();

import * as logoSlider from './scripts/logo-slider';
logoSlider.init();

import * as teaserSliderLg from './scripts/teaser-slider-lg';
teaserSliderLg.init();

// Product Slider
import * as productGenericSlider from './scripts/product-generic-slider';
productGenericSlider.init();

// Content-teaser-slider
import * as genericSlider from './scripts/generic-slider';
genericSlider.init();

import * as tabs from './scripts/tabs';
tabs.init();


//bootstrap imports
import Collapse from 'bootstrap/js/dist/collapse';

import * as accordion from './scripts/accordion.js';
accordion.init();

import * as factArea from './scripts/fact-area';
factArea.init();